<div class="wrapper full-width bg-gray-lighter" [class.wcm-division]="userDivision == UserDivision.WCM">
  <div class="navbar navbar-footer navbar-border">
    <div class="container-fluid footer-font">
      <div class="flex-navbar-footer">
        <span class="navbar-brand">SYNC LICENSING PITCH</span>
      </div>

      <div class="flex-navbar-text">
        <p>© Copyright {{ currentYear }} Warner Music Group</p>
      </div>
    </div>
  </div>
</div>
